// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-scrollcontainer_default__20sc5"};